export default "__VITE_ASSET__CzCZGitG__"